import { createAction, props } from '@ngrx/store';
import { IPensionState } from './pension.state';

export const initPensionAction = createAction('[Pension Page] Pension page');

export const setPensionAction = createAction(
  '[Pension Page] set data',
  props<IPensionState>()
);
